import axiosInstance from '../api';

const inspectionPriceService = {
  get: async (listingId: string) => {
    const res = await axiosInstance.get(`/inspection-price/${listingId}`);
    return res.data;
  },
};

export default inspectionPriceService;
